export default "__VITE_ASSET__$x61Rb5j__"